export const ProductSliderStyles = {
    sliderContainer:'brandProductSlider [&>div>button]:!hidden',
 }
 export const ProductSliderCardsStyles = {
    slickSlide:"flex ",
    slickSlideImage: 'w-full'
 }